<div class="flex h-full w-full flex-col items-center justify-center">
  @if (iconSrc()) {
    <img [src]="iconSrc()" alt="" class="mb-2 h-16 w-16 object-contain text-gray-400" />
  } @else {
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
      class="mb-2 text-gray-400" aria-hidden="true">
      <path d="M3 3v18h18" />
      <path d="M18 17V9" />
      <path d="M13 17V5" />
      <path d="M8 17v-3" />
    </svg>
  }

  <h3 class="mt-2 text-lg font-semibold text-gray-900 dark:text-zinc-100">{{ title() }}</h3>
  <p class="mt-2 max-w-sm text-center text-md text-gray-500 dark:text-zinc-400">{{ description() }}</p>

  @if (hasConfirmButton() || hasCancelButton()) {
    <div class="mt-4 flex items-center justify-center gap-3">
      @if (hasConfirmButton()) {
        <button type="button" class="btn-basic btn-primary" (click)="onButtonClick('confirm')">
          {{ confirmButtonText() }}
        </button>
      }
      @if (hasCancelButton()) {
        <button type="button" class="btn-basic btn-alert" (click)="onButtonClick('cancel')">
          {{ cancelButtonText() }}
        </button>
      }
    </div>
  }
</div>
